import React from 'react';
import { Badge } from 'reactstrap';

import { MatchType } from './matchType';

interface ComponentProps {
  type: MatchType;
}

const MatchBadge: React.FC<ComponentProps> = ({ type }) => {
  if (type === 'auto') return <Badge color="success">Auto</Badge>;
  if (type === 'choose') return <Badge color="warning">Choose</Badge>;
  return <Badge color="danger">No Match</Badge>;
};

export default MatchBadge;
